import { render, staticRenderFns } from "./BatchAdd.vue?vue&type=template&id=e68ce7b0"
import script from "./BatchAdd.vue?vue&type=script&lang=js"
export * from "./BatchAdd.vue?vue&type=script&lang=js"
import style0 from "./BatchAdd.vue?vue&type=style&index=0&id=e68ce7b0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports